import { render, staticRenderFns } from "./MainSettingsTab.vue?vue&type=template&id=18955707&scoped=true&"
import script from "./MainSettingsTab.vue?vue&type=script&lang=js&"
export * from "./MainSettingsTab.vue?vue&type=script&lang=js&"
import style0 from "./MainSettingsTab.vue?vue&type=style&index=0&id=18955707&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18955707",
  null
  
)

export default component.exports